import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { NotificationBell } from "@/components/NotificationBell";
import { FieldReadabilityToggle } from "@/components/FieldReadabilityToggle";
import logo from "@/assets/Struvent-Logo-2.png";

export function HomeHeader() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between mb-12 pt-12 md:pt-0" data-tour="header">
      <div className="flex items-center gap-4">
        <img
          src={logo}
          alt="Struvent"
          className="h-32 w-32 object-contain bg-white rounded-lg p-2 shadow-sm"
        />
        <div>
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground">
            Struvent
          </h1>
          <p className="text-sm text-muted-foreground font-medium tracking-wide">
            Crose and Lemke Construction, Inc.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 fixed top-4 right-4 z-50 md:relative md:top-0 md:right-0 md:z-0">
        <FieldReadabilityToggle variant="inline" />
        <NotificationBell />
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate("/more")}
          data-tour="menu-button"
        >
          Menu
        </Button>
      </div>
    </div>
  );
}